import React, { useEffect, useState } from "react";
import HeadingComponent from "../../../component/atom/Headings/Heading";
import { Box } from "@mui/material";
import {
  DialogComponent,
  SearchBarComponent,
  TextIconButtonComponent,
} from "../../../component/atom";
import DropDownComponent from "../../../component/atom/Inputs/DropDown";
import { CreateForumForm, MainForumCard } from "../../../component/molecule";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { Actions } from "../../../core/modules/Actions";
import _, { initial } from "lodash";
import { getText } from "../../../core/Constant";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

const ForumMainScreen = ({
  forumList,
  getForumList,
  joinForum,
  verifyToken,
  getStdCourseList,
  stdCourseList
}) => {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [newcourseList, setCourseList] = useState([]);
  const [course, setCourse] = useState();
  const [originalList, setOriginalList] = useState();

  useEffect(() => {
    if (course == null || Number.isNaN(Number(course))) {
      return;
    }
    const result = _.map(forumList, ({ id, forums }) => ({ id, forums }));
    const foundObject = _.find(result, ({ id }) => Number(id) === Number(course)
    );
    setList(foundObject?.forums);
    setOriginalList(foundObject?.forums);
  }, [forumList, course]);


  useEffect(() => {
    getStdCourseList();
  }, []);


  useEffect(() => {
    const list = _.map(stdCourseList, (item) => ({
      id: parseInt(item.course_id, 10),
      course_id: parseInt(item.course_id, 10),
      name: item.course_name,
    }));
    setCourseList(list);
    const defaultCourse = list[0]?.id;
    setCourse(defaultCourse);
  }, [stdCourseList]);

  useEffect(() => {
    getForumList({ dashboard: 2 });
  }, []);



  const navigateToForumMessage = (item) => {
    // 👇️ navigate to /contacts
    navigate("/forum-message", {
      state: { forumId: _.get(item, "id", ""), forum: item },
    });
  };

  const onChange = (value) => {
    const text = getText(value);
    if (text == "" || text == null) {
      setList(originalList);
    } else {
      var filteredData = list.filter(function (values) {
        var search_string =
          values.name;
        return search_string.toLowerCase().includes(text.toLowerCase());
      });
      const data2 = _.values(filteredData);
      setList(data2);
    }
    setText(text);

  };


  const onCourseChange = (e) => {
    const Selectedvalue = parseInt(getText(e), 10);
    if (Number.isNaN(Selectedvalue)) {
      return;
    }
    setCourse(Selectedvalue);
    localStorage.setItem("firstcourse", Selectedvalue.toString());
    const result = _.map(forumList, ({ id, forums }) => ({ id, forums }));
    const foundObject = _.find(
      result,
      ({ id }) => Number(id) === Selectedvalue
    );
    setList(foundObject?.forums);
    setOriginalList(foundObject?.forums);
  };

  return (
    <>
      <Box className="main-screen-container">
        <Box mt={3}>
          <HeadingComponent
            text={"Forum"}
            fontweigth={600}
            size={26}
            fontfamily={"Montserrat"}
          />
        </Box>
        <Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: 'center',
              mt: 3.5,
              mb: 2.5
            }}
          >
            <SearchBarComponent value={text} onchange={onChange} />
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', flexDirection: 'row', flex: 0.8 }}>
              <Box sx={{ flex: 0.4 }}>
                <DropDownComponent
                  isShowPlaceholder={true}
                  isShowZero={newcourseList.length > 0 ? false : true}
                  initialValue="Select Course"
                  onchange={onCourseChange}
                  radius={"15px"}
                  list={newcourseList}
                  selectedValue={course}
                />
              </Box>
              <Box>
                <TextIconButtonComponent btnText={"Create a forum"} icon={faPlus} onclick={() => setOpen(true)} />

              </Box>

            </Box>
          </Box>

          {list && list.map((item, index) => {
            return (
              <MainForumCard
                onJoinForm={() => {
                  joinForum({ forum_id: item.id });
                }}
                item={item}
                key={`std_forum-${index}_number`}
                onForumView={() => navigateToForumMessage(item)}
              />
            );
          })}
        </Box>


      </Box>
      <DialogComponent
        isShowCloseButton={false}
        title={
          <span className="modalTitle modalTitleBlack">
            Create new{" "}
            <span
              style={{ color: "#9834F0" }}
              className="modalTitle modalTitleGreen"
            >
              forum
            </span>
          </span>
        }
        open={open}
        onClose={() => setOpen(false)}
        backgroundColor={"#fffff"}
      >
        <CreateForumForm courseList={newcourseList} onClose={() => setOpen(false)} />
      </DialogComponent>
    </>
  );
};

export default connect(
  (state) => ({
    forumList: state.forum.get("forumList"),
    stdCourseList: state.course.get("stdCourseList"),
    courseList: state.course.get("commonCourseList"),
  }),
  {
    getForumList: Actions.forum.getForumList,
    joinForum: Actions.forum.joinForum,
    verifyToken: Actions.auth.verifyToken,
    getCourseList: Actions.course.getCourseList,
    getStdCourseList: Actions.course.getStdCourseList,
  }
)(ForumMainScreen);
